import { defineComponent, computed } from "vue";
import Price from "./component-library10.mjs";
import Heading from "./component-library6.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "prices",
  props: {
    theme: { default: void 0 },
    variant: { default: void 0 },
    preTextIsPrice: { default: void 0 },
    postTextIsPrice: { default: void 0 },
    preTextWasPrice: { default: void 0 },
    postTextWasPrice: { default: void 0 },
    title: { default: void 0 },
    isPrice: { default: void 0 },
    wasPrice: { default: void 0 },
    isPriceBold: { type: Boolean },
    isWasPriceBold: { type: Boolean }
  },
  setup(__props, { expose }) {
    const props = __props;
    const themeClass = computed(() => {
      if (!props.theme)
        return void 0;
      return `prices--${props.theme}`;
    });
    expose({ themeClass });
    return { __sfc: true, props, themeClass, Price, Heading };
  }
});
export {
  _sfc_main as default
};
